import api from "src/api/axios";

const updateProfile = async (input) => {
  return api.patch(`/profile`, input).then((result) => {
    return result.data;
  });
};

const getProfile = async (id) => {
  return api.get(`/profile`).then((result) => {
    return result.data;
  });
};

export { getProfile, updateProfile };
